module.exports = __webpack_public_path__ + "img/02@2x.a0f45c5b.png";